const SET = 'learningData.SET';

const defaultState = {
  stgCd : '',
  resultAni : false,
  resultFoldingFlag : false,
  prevPage : '',
  effortThree : false, //노력3회
  rcmnSbthmaCd : "", //추천소주제코드
  resumeLeanInfo : null
};

const setLearningDataAction = data => ( { type : SET, data : data } );

const learningData = ( state=defaultState, action ) => {

  switch ( action.type ) {
    case SET :
      return { ...state, ...action.data };
    default :
      return state;
  }

};

export default learningData;
export { setLearningDataAction };
